<div class="btn-group btn-group-toggle" data-toggle="buttons">
  @for (category of categories; track category) {
    <label class="btn btn-secondary" [ngClass]="{'active': category.name === selected}">
      <input type="radio"
        name="category"
        autocomplete="off"
        value="{{category.name}}"
        [checked]="category.name === selected"
        (click)="onSelect(category)"
        > {{category.name}}
      </label>
    }
  </div>
